import React from 'react';
import styled from 'styled-components';
import {createSelector} from 'reselect';
import {useSelector} from 'react-redux';

import {hotelName as hotelNameSelectorFn, aboutPropertySelectorFn, propertyTypeSelectorFn} from '../../selectors';

import * as S from './HotelDetails.styles';

import HotelRatingStars from './HotelRatingStars';
import HotelAddressText from './HotelAddressText';


function HotelName() {
  const hotelNameSelector = createSelector([hotelNameSelectorFn], hotelName => hotelName);

  const hotelName = useSelector(hotelNameSelector);
  const aboutProperty = useSelector(aboutPropertySelectorFn);
  const propertyType = useSelector(propertyTypeSelectorFn);
  // console.log('aboutProperty = ', aboutProperty);
  return (
    <S.HotelInfoWrap>
      <S.HotelTypeTagWrap>
        <S.HotelTypeTag>
          <S.HotelTypeText>{propertyType}</S.HotelTypeText>
        </S.HotelTypeTag>
      </S.HotelTypeTagWrap>
      <S.HotelNameRatingWrap>
        <S.HotelNameAddressWrap>
          <S.HotelNameWrap>
            <S.HotelNameText>
              {hotelName}
            </S.HotelNameText>
            <S.HotelStarWrap>
              <HotelRatingStars />
            </S.HotelStarWrap>
          </S.HotelNameWrap>
          <HotelAddressText />
        </S.HotelNameAddressWrap>
      </S.HotelNameRatingWrap>
      {/* <S.HotelDetailText>
        {aboutProperty}
      </S.HotelDetailText> */}
    </S.HotelInfoWrap>
  );
}

export default HotelName;
